// 大写首字母
const firstUpperCase = str => {
    return str.replace(/( |^)[a-z]/g, L => L.toUpperCase());
};
// params 返回 string
const urlStringify = params => {
    const list = Object.keys(params)
        .map(item => {
            return item + '=' + params[item];
        })
        .join('&');
    return list;
};
// params 返回 string
const strStringify = (params, seg, segjoin) => {
    const list = Object.keys(params)
        .map(item => {
            return item + (seg || '=') + params[item];
        })
        .join(segjoin || '&');
    return list;
};
// 返回对象，路径值
const _get = (data, dataPath) => {
    if (dataPath.substr) {
        dataPath = dataPath.split(/\.|\\|\//);
    }
    if (dataPath.length && data) {
        return _get(data[dataPath.shift()], dataPath);
    } else if (!dataPath.length && data) {
        return data;
    } else {
        return '';
    }
};
export { firstUpperCase, urlStringify, strStringify, _get };



// WEBPACK FOOTER //
// ./src/util/string.js